export const DUMMY_CLASSROOMS = [
  {
    id: 1,
    created_at: 1709789414872,
    code: 'l5AhSmZT',
    name: '8th Grade Algebra',
    description: '8th Grade Dummy Algebra Classrooms for trial',
    grades_id: 10,
    grades: {
      id: 10,
      created_at: 1667470488260,
      grade: '8th',
    },
    subject_id: [
      {
        id: 1,
        created_at: 1667470488260,
        subject: 'Algebra I',
      },
    ],
    subject: 'Algebra I',
    current_subject_id: 1,
    user_id: 0,
    test_day: 5,
    isArchive: 0,
    new_user_ids: [],
    is_dummy: true,
    extras: {
      eventDates: [
        { day: 'monday', end: 1679590500000, start: 1679587440000, period: 'Period 2', subject_id: 1 },
        { day: 'tuesday', end: 1679590500000, start: 1679587440000, period: 'Period 2', subject_id: 1 },
        { day: 'wednesday', end: 1679590500000, start: 1679587440000, period: 'Period 2', subject_id: 1 },
        { day: 'thursday', end: 1679590500000, start: 1679587440000, period: 'Period 2', subject_id: 1 },
        { day: 'friday', end: 1679588460000, start: 1679586420000, period: 'Period 2', subject_id: 1 },
      ],
    },
  },
];
